export enum Culture {
	EsCo = 'es-CO',
	EsEc = 'es-EC',
	EsPe = 'es-PE',
	EsMx = 'es-MX',
	EnUs = 'en-US',
	PtBr = 'pt-BR',
}
